export default __webpack_public_path__ + "static/media/campus photo.160eff25.jpg";